import { JSX } from "react";

export function Tasks(): JSX.Element {
  return <div>Tâches</div>;
}
